import React, { forwardRef } from 'react';
import {
  FieldProps,
  InjectedFieldProps,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin';

import MenuItem from '@material-ui/core/MenuItem';

import { Confirmation } from 'components/common';
import { RewardLevelDto } from '../../types';

type DeleteLevelActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardLevelDto;
};

const DeleteLevelActionField = forwardRef<HTMLLIElement, DeleteLevelActionFieldProps>(
  ({ record }, ref) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleDeleteLevel = async () => {
      if (!record?.id) {
        return;
      }

      try {
        await dataProvider.delete('rewardsLevel', { id: record.id });
        refresh();
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : 'Failed to delete rewards level';
        notify(message);
      }
    };

    return (
      <Confirmation title="Delete level" content="Are you sure you want to delete this level?">
        <MenuItem ref={ref} onClick={handleDeleteLevel}>
          Delete
        </MenuItem>
      </Confirmation>
    );
  }
);

export default DeleteLevelActionField;
